// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer :nth-child(3) {
  padding-bottom: 30px;
}

.SWA-disclaimer-text {
  color: white;
}

.SWA-disclaimer-link {
  font-family: "Vodafone Rg";
  font-size: 14px;
  color: #fff !important;
  text-decoration: none;
}
.SWA-disclaimer-link:hover, .SWA-disclaimer-link:focus {
  text-decoration: underline !important;
}`, "",{"version":3,"sources":["webpack://./src/components/footer/footer.scss"],"names":[],"mappings":"AACI;EACI,oBAAA;AAAR;;AAGA;EACI,YAAA;AAAJ;;AAGA;EACI,0BAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;AAAJ;AACI;EACI,qCAAA;AACR","sourcesContent":[".footer {\n    & :nth-child(3) {\n        padding-bottom: 30px;\n    }\n}\n.SWA-disclaimer-text{\n    color: white;\n}\n\n.SWA-disclaimer-link{\n    font-family: 'Vodafone Rg';\n    font-size: 14px;\n    color: #fff !important;\n    text-decoration: none;\n    &:hover, &:focus{\n        text-decoration: underline !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
